module.exports = __webpack_public_path__ + "static/media/zeitchick.4bdcb779.jpg";